import "core-js/stable";
import "regenerator-runtime/runtime";

import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import './permission.js'

import Topbar from "@/components/commonality/publicTopbar.vue";
import Footer from "@/components/commonality/publicFooter.vue";


import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

import i18n from "./locales/i18n";

Vue.config.productionTip = false;

// 引入样式
import "@/styles/common.css";
import "@/styles/commons.css";
// import "@/styles/color.css";
import "@/styles/ColorMatching.css";

// import "@/assets/tailwind.css";
import "./styles/tailwind.css"; // 引入 Tailwind

import cssVars from "css-vars-ponyfill";

cssVars({
  watch: true, // 监听 DOM 变化，动态更新变量
  onlyLegacy: true, // 只在需要时（IE）才工作，现代浏览器跳过
  variables: {
    // 可选：手动设置 CSS 变量的默认值，防止未定义
    "--color-primary": "#3490dc",
  },
});

// 挂载日期格式处理
import moment from "moment";
Vue.prototype.$moment = moment;
import dayjs from "dayjs"; // 1. 引入 dayjs
Vue.prototype.$dayjs = dayjs;

Vue.filter("fmDate", (v, f = "YYYY-MM-DD") => {
  if (v) return moment(v).format(f);
  return "";
});
// 设置浏览器标题

// 跳转后返回顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});

// import'./styles/custom.css';

Vue.use(ElementUI); // 引入element-ui
Vue.component("Topbar", Topbar);
Vue.component("Footer", Footer);

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
